module.exports = __webpack_public_path__ + "img/68_43.250151ff.png";